import UserRequest from '@/http/UserRequest'

const user = {
  namespaced: true,
  state: {
    users: [],
    authorityList: [],
  },
  getters: {
    getUsers: (state) => {
      return state.users.list
    },
    getUserById: (state) => (id) => {
      const user = state.users.list.find((user) => {
        return user.id === id
      })
      return user || null
    },
    getAuthorityList: (state) => {
      return state.authorityList
    },
  },
  actions: {
    getUsers: ({ commit }) => {
      const request = new UserRequest()
      request.getList().then((res) => {
        commit('setUsers', res.data)
      })
    },
    getAuthorities: ({ commit }) => {
      const request = new UserRequest()
      var authorityList = []
      request.authorities().then((res) => {
        res.data.list.forEach((element) => {
          authorityList.push(element.viewId)
        })
      })
      commit('setAuthorityList', authorityList)
    },
  },
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setAuthorityList(state, authorityList) {
      state.authorityList = authorityList
    },
  },
}

export default user
